export default __webpack_public_path__ + "static/3-ea5979634555711972999b5464a709a6.png";